import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Tooltip } from '@mui/material';

import {
	faDisplayChartUpCircleDollar,
	faHandHoldingDollar,
	faEnvelope,
	faCheck,
} from '@fortawesome/pro-regular-svg-icons'

const Symbol = ({ tooltip, icon, icon2, color }) => {
	return (
		<Box sx={{ display:'inline', mr:1 }}>
			<Tooltip title={tooltip}>
				<span className="fa-layers fa-fw fa-lg">
					<FontAwesomeIcon icon={icon} color={color || undefined} />
					{ icon2 && <FontAwesomeIcon icon={icon2} color={color || undefined} /> }
				</span>
			</Tooltip>
		</Box>
	)
}

export const Status = ({ _state }) => {
	const content = []

	if(!!_state?.notify)
		content.push(
			<Symbol icon={faEnvelope} tooltip="Notifica via mail" />
		)
	else if(!!_state?.telematic)
		content.push(
			<Symbol icon={faDisplayChartUpCircleDollar} tooltip="Servizio telematico" />
		)
	else
		content.push(
			<Symbol icon={faHandHoldingDollar} tooltip="Consegna manuale" />
		)

	if(!!_state?.locked)
		content.push(
			<Symbol icon={faCheck} tooltip="Anagrafica elaborata" />
		)

	return content
}